import { LocalDate } from "@js-joda/core";
import React from "react";
import { formatPhone } from "../../../phone_number";
import { STRINGS } from "../../../strings";
import { globalize, translate } from "../../../translate";
import { fmap } from "../../../utils/fmap";
import { AppCard, AppCardContent, AppCardHeader, AppCardTitle } from "../../Generic/AppCard";
import { AppList, AppListItem } from "../../Generic/AppList";
import PatientDetailsNoValue from "./PatientDetailsNoValue";

interface Props {
  dateOfBirth: LocalDate | null;
  gender: string | null;
  homePhoneNumber: string | null;
  mobilePhoneNumber: string | null;
  phone3: string | null;
  phone4: string | null;
}

const PatientDetailsCard = (props: Props) => {
  return (
    <AppCard key="patientDetails">
      <AppCardHeader>
        <AppCardTitle>Patient Details</AppCardTitle>
      </AppCardHeader>
      <AppCardContent>
        <AppList>
          <AppListItem
            title={<b>{translate(STRINGS.DATE_OF_BIRTH)}</b>}
            trailing={
              fmap(props.dateOfBirth, (x) => globalize().formatLocalDate(x)) ?? (
                <PatientDetailsNoValue />
              )
            }
          />
          <AppListItem
            title={<b>{translate(STRINGS.GENDER)}</b>}
            trailing={props.gender ?? <PatientDetailsNoValue />}
          />
          <AppListItem
            title={<b>{translate(STRINGS.HOME_PHONE)}</b>}
            trailing={
              fmap(props.homePhoneNumber, (x) => formatPhone(x)) ?? <PatientDetailsNoValue />
            }
          />
          <AppListItem
            title={<b>{translate(STRINGS.MOBILE_PHONE)}</b>}
            trailing={
              fmap(props.mobilePhoneNumber, (x) => formatPhone(x)) ?? <PatientDetailsNoValue />
            }
          />
          <AppListItem
            title={<b>{translate(STRINGS.PHONE) + "3"}</b>}
            trailing={fmap(props.phone3, (x) => formatPhone(x)) ?? <PatientDetailsNoValue />}
          />
          <AppListItem
            title={<b>{translate(STRINGS.PHONE) + "4"}</b>}
            trailing={fmap(props.phone4, (x) => formatPhone(x)) ?? <PatientDetailsNoValue />}
          />
        </AppList>
      </AppCardContent>
    </AppCard>
  );
};

export default PatientDetailsCard;
